<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Prénom</mat-label>
          <input
            matInput
            placeholder=""
            type="text"
            required
            formControlName="firstName"
          />
          <mat-error>
            <span *ngIf="f('firstName').hasError('required')"
              >Veuillez saisir un prénom</span
            >
            <span *ngIf="f('firstName').hasError('maxlength')"
              >Le prénom ne doit pas dépasser 50 caractères</span
            >
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Nom</mat-label>
          <input
            matInput
            placeholder=""
            type="text"
            required
            formControlName="name"
          />
          <mat-error>
            <span *ngIf="f('name').hasError('required')"
              >Veuillez saisir un nom</span
            >
            <span *ngIf="f('name').hasError('maxlength')"
              >Le nom ne doit pas dépasser 50 caractères</span
            >
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Adresse email</mat-label>
          <input
            matInput
            type="email"
            required
            formControlName="email"
            placeholder=""
            email
          />
          <mat-error>
            <span *ngIf="f('email').hasError('required'); v"
              >Veuillez saisir une adresse email</span
            >
          </mat-error>
          <mat-error>
            <span *ngIf="f('email').hasError('email')"
              >Veuillez saisir une adresse email valide</span
            >
          </mat-error>
          <mat-error>
            <span *ngIf="f('email').hasError('exists')"
              >Cette adresse email est déjà utilisée</span
            >
          </mat-error>
          <mat-error>
            <span *ngIf="f('email').hasError('notManaged')"
              >Cet email est géré de mmanière externe.</span
            >
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Rôle</mat-label>
          <mat-select formControlName="role" required placeholder="">
            <mat-option value="INDIVIDUAL">{{
              userHelper.getRoleName("INDIVIDUAL")
            }}</mat-option>
            <mat-option value="PROFESSIONAL">{{
              userHelper.getRoleName("PROFESSIONAL")
            }}</mat-option>
            <mat-option value="REAL_ESTATE">{{
              userHelper.getRoleName("REAL_ESTATE")
            }}</mat-option>
            <mat-option value="NOTARY">{{
              userHelper.getRoleName("NOTARY")
            }}</mat-option>
            <mat-option value="RESCUE_SERVICE">{{
              userHelper.getRoleName("RESCUE_SERVICE")
            }}</mat-option>
            <mat-option *ngIf="data.edition" value="EEMO">{{
              userHelper.getRoleName("EEMO")
            }}</mat-option>
            <mat-option *ngIf="data.edition" value="ADMIN">{{
              userHelper.getRoleName("ADMIN")
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Téléphone</mat-label>
          <input
            matInput
            placeholder=""
            type="text"
            formControlName="phoneNumber"
          />
          <mat-error>
            <span *ngIf="f('phoneNumber').hasError('phoneNumber')">{{
              "error.phoneNumber" | translate
            }}</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <a class="ml-3" (click)="toggleShowAddress()">
          <mat-icon
            *ngIf="!showAddress"
            color="primary"
            appTooltip="Ajouter une adresse"
            >mark_email_read</mat-icon
          >
          <mat-icon
            *ngIf="showAddress"
            color="primary"
            appTooltip="Supprimer l'adresse"
            >unsubscribe</mat-icon
          >
        </a>
        <a
          *ngIf="showAddress"
          class="ml-3"
          (click)="fillAddressFromProperty()"
          appTooltip="Chercher l'adresse d'un bien existant"
        >
          <mat-icon
            color="primary"
            aria-label="Chercher l'adresse d'un bien existant"
            >search</mat-icon
          >
        </a>
      </div>
      <div *ngIf="showAddress" formGroupName="address">
        <div class="form-group row">
          <mat-form-field class="col-md-6">
            <mat-label>Numéro et Rue</mat-label>
            <input
              matInput
              placeholder=""
              type="text"
              required
              formControlName="street"
            />
            <mat-error>
              <span *ngIf="fAddr('street').hasError('required')"
                >Veuillez saisir une rue</span
              >
              <span *ngIf="fAddr('street').hasError('maxlength')"
                >Le nom ne doit pas dépasser 255 caractères</span
              >
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-6">
            <mat-label>Complément</mat-label>
            <input
              matInput
              placeholder=""
              type="text"
              formControlName="complement"
            />
            <mat-error>
              <span *ngIf="fAddr('complement').hasError('maxlength')"
                >Le complément ne doit pas dépasser 255 caractères</span
              >
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group row">
          <mat-form-field class="col-md-6">
            <mat-label>Code Postal</mat-label>
            <input
              matInput
              placeholder=""
              type="text"
              required
              formControlName="postalCode"
            />
            <mat-error>
              <span *ngIf="fAddr('postalCode').hasError('required')"
                >Veuillez saisir un code postal</span
              >
              <span *ngIf="fAddr('postalCode').hasError('postalCode')"
                >Format de code postal invalide</span
              >
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-6">
            <mat-label>Ville</mat-label>
            <input
              matInput
              placeholder=""
              type="text"
              required
              formControlName="city"
            />
            <mat-error>
              <span *ngIf="fAddr('city').hasError('required')"
                >Veuillez saisir une ville</span
              >
              <span *ngIf="fAddr('city').hasError('maxlength')"
                >La ville ne peut pas dépasser 40 caractères</span
              >
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group row">
          <mat-form-field class="col-md-6">
            <mat-label>Pays</mat-label>
            <input
              matInput
              placeholder=""
              type="text"
              formControlName="country"
            />
            <mat-error>
              <span *ngIf="fAddr('country').hasError('maxlength')"
                >La pays ne peut pas dépasser 40 caractères</span
              >
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="!this.data.edition" class="ml-3 mt-2 form-group">
        <mat-checkbox formControlName="sendInformations"
          >Envoyer les informations à l'utilisateur</mat-checkbox
        >
        <div *ngIf="this.f('sendInformations').value">
          <mat-hint>Mot de passe généré automatiquement</mat-hint>
        </div>
      </div>
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Mot de passe</mat-label>
          <input
            matInput
            [required]="!this.data.edition"
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            placeholder=""
          />
          <mat-icon
            matSuffix
            role="button"
            [appTooltip]="
              hidePassword
                ? 'Afficher le mot de passe'
                : 'Masquer le mot de passe'
            "
            (click)="hidePassword = !hidePassword"
            >{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon
          >
          <mat-hint *ngIf="this.data.edition"
            >Si non saisi, le mot de passe n'est pas modifié</mat-hint
          >
          <mat-error>
            <span *ngIf="f('password').hasError('required')"
              >Veuillez saisir le mot de passe</span
            >
            <span *ngIf="f('password').hasError('passwordDontMatch')"
              >Les mots de passe ne correspondent pas</span
            >
            <span *ngIf="f('password').hasError('pattern')"
              >Mot de passe trop simpliste<mat-icon
                mdbPopover="Saisir au moins 8 caractères, dont 1 majuscule, 1 minuscule et 1 chiffre"
                trigger="focus"
                tabindex="0"
                >info</mat-icon
              ></span
            >
            <span *ngIf="f('password').hasError('refusedPassword')"
              >Mot de passe non autorisé<mat-icon
                mdbPopover="Trop de caractères identiques consécutifs (maximum 3)"
                trigger="focus"
                tabindex="0"
                >info</mat-icon
              ></span
            >
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Confirmer le mot de passe</mat-label>
          <input
            matInput
            [required]="!this.data.edition"
            [type]="hidePasswordConfirm ? 'password' : 'text'"
            formControlName="passwordConfirmed"
            placeholder=""
          />
          <mat-icon
            matSuffix
            role="button"
            [appTooltip]="
              hidePasswordConfirm
                ? 'Afficher le mot de passe'
                : 'Masquer le mot de passe'
            "
            (click)="hidePasswordConfirm = !hidePasswordConfirm"
            >{{
              hidePasswordConfirm ? "visibility_off" : "visibility"
            }}</mat-icon
          >
          <mat-error>
            <span *ngIf="f('passwordConfirmed').hasError('required')"
              >Veuillez confirmer le mot de passe</span
            >
          </mat-error>
        </mat-form-field>
      </div>

      <div class="formValidation" class="text-center">
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          appTooltip="Valider"
          type="submit"
          [disabled]="formSubmitting"
        >
          Valider
        </button>
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          mat-dialog-close
          appTooltip="Annuler"
          (click)="onNoClick()"
        >
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
